import React from 'react';
import { useTranslation } from 'react-i18next';

const TestimonialCard = ({ className }) => {
  const { t } = useTranslation();
  const testimonialData = t('sections.testimonialCard.testimonials', { returnObjects: true, defaultValue: [
    {
      title: 'Mr. Michel Phelops',
      subtitle: 'UX Designer',
      text: "We were impressed with Secur's ability to tailor their services to our specific needs. Their in-depth knowledge and expertise helped us identify and address potential vulnerabilities before they could cause serious damage.",
      rating: 5.0,
      ratingCount: 1
    },
    {
      title: 'Andy Dufren',
      subtitle: 'UX Designer',
      text: "Before partnering with Secur, we were constantly worried about potential data breaches. Their team stays ahead of the latest threats. We've significantly reduced our risk and can now focus on business.",
      rating: 5.0,
      ratingCount: 1
    },
    {
      title: 'Sarah Rahman',
      subtitle: 'UX Designer',
      text: "We were struggling to manage our growing cloud infrastructure and protect our sensitive data. Secur's expert team provided us with a comprehensive security solution that not only met our needs but exceeded our expectations.",
      rating: 5.0,
      ratingCount: 1
    }
  ] });

  return (
    <>
      {testimonialData.map((testimonial, index) => (
        <div className={className} key={index}>
          <div className="testi-card" data-cue="slideInUp">
            <h3 className="box-title">{testimonial.title}</h3>
            <span className="box-subtitle">{testimonial.subtitle}</span>
            <div className="star-rating" role="img" aria-label={t('sections.testimonialCard.rating_aria', { rating: testimonial.rating, defaultValue: `Rated ${testimonial.rating} out of 5` })}>
              <span>
                {t('sections.testimonialCard.rating_text', { rating: testimonial.rating, count: testimonial.ratingCount, defaultValue: 'Rated {{rating}} out of 5 based on {{count}} customer rating' })}
              </span>
            </div>
            <div className="testi-card-content">
              <p className="box-text">{testimonial.text}</p>
            </div>
          </div>
        </div>
      ))}
    </>
  );
};

export default TestimonialCard;